<app-navbar [title]="'Oferty'">
	<!--
	<a routerLink="./add" class="btn btn-danger">
		<i class="fas fa-plus"></i> Dodaj
	</a>
-->
</app-navbar>

<div id="loader" *ngIf="loader"><span class="spinner-border spinner-grow-lg"></span></div>

<app-dynamic-table
	[elements]="offers"
	[tableRows]="tableRows"
	[module]="'offers'"
	(filtersClicked)="filtersOpen()"
></app-dynamic-table>
